import { YoutubeUrl } from './types';
import { ResponsiveFrameWrapper, ResponsiveIframe } from './ExternalEmbedUI';

interface IProps {
  parsedUrl: YoutubeUrl;
}

export const YoutubeEmbed = ({ parsedUrl }: IProps) => {
  return (
    <ResponsiveFrameWrapper>
      <ResponsiveIframe
        src={`https://www.youtube.com/embed/${parsedUrl.videoId}`}
        allowFullScreen
        frameBorder="0"
      ></ResponsiveIframe>
    </ResponsiveFrameWrapper>
  );
};
